import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "./components/multilanguage/i18n";
import ReactGA from 'react-ga4';

// ── Google Analytics ──
// Production and dev/stage use separate GA4 properties so test traffic
// never pollutes production reports. Environment is determined by
// getEnvironment() which checks window.location.hostname.
import { getEnvironment } from './components/common/getEnvironment';

const GA_PRODUCTION_ID = "G-XJ8G8RFGS9";
const GA_DEV_ID = "G-JYWVGHGB8E";

const isProduction = getEnvironment() === "production";
const MEASUREMENT_ID = isProduction ? GA_PRODUCTION_ID : GA_DEV_ID;

// Disable the automatic initial page_view — our SPA-aware PageViewTracker
// in App.tsx fires page_view on every route change (including first load)
// with a consistent snake_case page_title.
// debug_mode is enabled for non-production so events show in GA DebugView
// without needing browser extensions.
ReactGA.initialize(MEASUREMENT_ID, {
    gtagOptions: {
        send_page_view: false,
        ...(!isProduction && { debug_mode: true }),
    },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

    <App />

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
